import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = "schock_token";

export const tokenStore = {
    get: () => {
        try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
    },
    set: (v) => {
        try { localStorage.setItem(TOKEN_KEY, v); } catch { /* ignore */ }
    },
    clear: () => {
        try { localStorage.removeItem(TOKEN_KEY); } catch { /* ignore */ }
    },
};

export const api = axios.create({
    baseURL: API_BASE,
    timeout: 20000,
});

api.interceptors.request.use((cfg) => {
    const t = tokenStore.get();
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    return cfg;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err.response?.status === 401) {
            tokenStore.clear();
        }
        return Promise.reject(err);
    }
);

export function formatApiError(detail, fallback = "Etwas ist schiefgelaufen.") {
    if (detail == null) return fallback;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return fallback;
}

// Resolve any uploaded image URL (returned from backend as /api/uploads/...)
export function resolveImage(url) {
    if (!url) return "";
    if (/^https?:\/\//i.test(url)) return url;
    return `${BACKEND_URL}${url}`;
}
